import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { useClientId } from '../../../_hooks/useClientId';
import { BankAccountBody } from '../Features/AccountPreferences/components/AccountForm/AccountForm.meta';

interface SaveAccountResponseDTO {
  AccountId: string;
}

const saveAccount = (clientId: number) => (
  bodyData: BankAccountBody,
): Promise<SaveAccountResponseDTO> =>
  authFetch(
    urlWithParams(`/Consumer/AccountUpdate/Save`, {
      clientId,
    }),
    {
      method: 'POST',
      ...httpBodyOptions(bodyData, true),
    },
  );

export const useAccountSaveMutation = () => {
  const clientId = useClientId();

  return useMutation(saveAccount(clientId));
};
